/**
 * API base URL for salon-admin backend requests.
 */
const DEFAULT_DEV_API_ORIGIN = 'http://localhost:5003';
const PRODUCTION_CUSTOMER_HOST = 'analyze.nyafaz.com';
const PRODUCTION_SALON_API_PATH = '/salon-admin-api';

function productionSalonApiOriginForHost(origin) {
  try {
    const url = new URL(origin);
    const host = String(url.hostname || '').toLowerCase();
    if (host === PRODUCTION_CUSTOMER_HOST) {
      return `${url.origin}${PRODUCTION_SALON_API_PATH}`;
    }
  } catch {
    // ignore invalid origin
  }
  return null;
}

function isSalonAdminDevOrigin(origin) {
  if (!origin) return false;
  try {
    const { hostname, port } = new URL(origin);
    const isLocalHost =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '[::1]' ||
      hostname.endsWith('.local');
    return isLocalHost && (port === '3000' || port === '3004' || port === '5173' || port === '');
  } catch {
    return false;
  }
}

export function getSalonAdminApiBaseUrl() {
  const fromSalonEnv =
    typeof process !== 'undefined' && process.env && process.env.REACT_APP_SALON_ADMIN_API_URL;
  if (fromSalonEnv && String(fromSalonEnv).trim()) {
    return String(fromSalonEnv).trim().replace(/\/$/, '');
  }

  const fromEnv =
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL) ||
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_BASE_URL);
  const normalizedFromEnv = fromEnv && String(fromEnv).trim() ? String(fromEnv).trim().replace(/\/$/, '') : '';

  if (typeof window !== 'undefined') {
    const fromWindow = window.REACT_APP_SALON_ADMIN_API_URL || window.REACT_APP_API_URL;
    if (fromWindow && String(fromWindow).trim()) {
      return String(fromWindow).trim().replace(/\/$/, '');
    }

    const origin = window.location && window.location.origin;
    if (isSalonAdminDevOrigin(origin)) {
      return DEFAULT_DEV_API_ORIGIN;
    }

    if (origin) {
      try {
        const mapped = productionSalonApiOriginForHost(origin);
        if (mapped) return mapped;
      } catch {
        // ignore invalid origin
      }
    }

    if (normalizedFromEnv) return normalizedFromEnv;
    if (origin) return origin;
  }

  if (normalizedFromEnv) return normalizedFromEnv;

  if (typeof window !== 'undefined' && window.location?.origin) {
    const mapped = productionSalonApiOriginForHost(window.location.origin);
    if (mapped) return mapped;
  }

  return DEFAULT_DEV_API_ORIGIN;
}
